import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { UserTokenService } from '@services/user-token.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
	selector: 'qe-callback',
	template: `<div role="none">Hello</div>`,
})

export class CallbackComponent implements OnInit, OnDestroy {
	private readonly ngUnsubscribe$: Subject<boolean> = new Subject();
	constructor(
		private readonly auth: AuthService,
		private readonly userTokenService: UserTokenService,
		private readonly router: Router,
	) { }

	ngOnInit(): void {
		this.auth.user$
			.pipe(takeUntil(this.ngUnsubscribe$))
			.subscribe(user => {
				this.userTokenService.setUserData(user);
				this.router.navigate(['/pet-information']);
			});
	}

	ngOnDestroy(): void {
		this.ngUnsubscribe$.next(true);
		this.ngUnsubscribe$.unsubscribe();
	}
}
